<template>
    <div class="forum-cantainer">
        <van-nav-bar title="会议论坛" left-arrow @click-left="back"></van-nav-bar>

        <router-link tag="div" to="forumOrder" class="my-forum">
            <div class="my-forum__title">已报名论坛</div>
        </router-link>
        <div class="content">
            <div class="list" v-for="item in forumList" :key="item.id">
                <div class="forum-content">
                    <div class="forum-item">
                        <div class="forum-banner">
                            <img :src="item.photo" alt />
                        </div>

                        <div class="forum-box">
                            <div class="title">
                                {{ item.title }}
                                <a v-if="item.url" :href="item.url">点击查看详情</a>
                            </div>
                            <div class="subTitle">{{ item.subTitle }}</div>
                            <div class="text">{{ item.address }}</div>
                            <div class="desc">
                                <div class="forum-time">{{ item.time }}</div>

                            </div>
                            <div class="select">
                                <div tag="div" @click="onEnterDetail(item)" class="sign-up">点击报名</div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import httpRequest from '@/module_visitor/api/http.js';
export default {
    data() {
        return {
            checkboxGroup: [],
            payPrice: 0,
            remark: this.$route.query.remark,
            isPay: this.$route.query.isPay,
            forumList: [],
            show: false,
            openid: undefined,
        };
    },

    methods: {
        back() {
            this.$router.go(-1);
        },
        onEnterDetail(item) {
            this.$router.push({
                path: '/forumDetail',
                query: {
                    id: item.id,
                    source: this.$route.query.source,
                    companyId: this.$route.query.companyId,
                    companyShareId: this.$route.query.companyShareId,
                    teamId: this.$route.query.teamId,
                },
            });
        },

        getData() {
            let params = {
                pageSize: 20,
                pageNum: 1,
            };
            httpRequest.get(`/api/forum/list`, params).then(res => {
                this.forumList = res.data.data;
            });
        },
    },
    mounted() {
        this.getData();
    },
    beforeCreate() {
        // var openid = localStorage.getItem('v_openid');
        // if (!openid) {
        //     this.$router.push('/getOpenId');
        // } else {
        //     this.openid = openid;
        // }
    },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/mixin.scss';

.forum-cantainer {
    width: 100%;
    min-height: 100vh;
    background: #f8f8f8;
    .my-forum {
        background: #2062f9;
        padding: 24px;
        margin: 16px;
        .my-forum__title {
            color: #fff;
        }
    }

    .content {
        .list {
            .forum-content {
                padding: 0 16px;
                margin-bottom: 8px;
                .forum-item {
                    background: #fff;
                    box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.05);
                    padding: 16px 8px;
                    border-radius: 8px;
                    display: flex;
                    .forum-banner {
                        width: 140px;
                        margin-right: 8px;
                        img {
                            width: 140px;
                            height: 90px;
                            object-fit: contain;
                        }
                    }
                    .forum-box {
                        flex: 1;
                        .title {
                            font-weight: 500;
                            padding: 5px 0;
                            a {
                                color: #00a5e5;
                            }
                        }
                        .subTitle {
                            line-height: 1.5;
                            font-size: 14px;
                            color: #777;
                            display: -webkit-box;
                            -webkit-line-clamp: 2;
                            -webkit-box-orient: vertical;
                            text-overflow: ellipsis;
                        }

                        .text {
                        }

                        .desc {
                            display: flex;
                            color: #777;
                            font-size: 12px;
                            padding: 4px 0;

                            .forum-time {
                            }

                            .forum-status {
                            }
                        }

                        .select {
                            display: flex;
                            justify-content: flex-end;

                            a {
                                font-size: 12px;
                            }

                            .sign-up {
                                font-size: 14px;
                                display: inline-block;
                                padding: 8px 20px;
                                border-radius: 4px;
                                background: linear-gradient(90deg, rgba(47, 107, 244, 0.62) -2.04%, #2062f9 100%);
                                color: #fff;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>